var React = require('react');

function ShareInWhite (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#fff","x":"0","y":"0","width":"19","height":"19","rx":"9.5","key":0}),React.createElement("path",{"d":"M6.88796 13.0875H5.06712V7.5375H6.88796V13.0875ZM5.89837 6.825C5.22546 6.825 4.79004 6.4125 4.79004 5.85C4.79004 5.2875 5.22546 4.875 5.89837 4.875C6.57129 4.875 7.00671 5.2875 7.00671 5.85C7.00671 6.4125 6.61087 6.825 5.89837 6.825ZM14.2109 13.0875H12.113V10.2C12.113 9.45 11.7963 8.925 11.0838 8.925C10.5296 8.925 10.2525 9.2625 10.0942 9.6C10.0546 9.7125 10.0546 9.9 10.0546 10.05V13.05H7.99629C7.99629 13.05 8.03587 7.95 7.99629 7.5H10.0546V8.3625C10.1734 7.9875 10.8463 7.425 11.8755 7.425C13.1817 7.425 14.2109 8.2125 14.2109 9.9375V13.0875Z","fill":"#141B2B","key":1})]);
}

ShareInWhite.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","version":"1.1"};

module.exports = ShareInWhite;

ShareInWhite.default = ShareInWhite;
